"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    'avatar.active.help': '非活跃头像对普通用户不可见',
};
